// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4cc1faa6","513":"79a76a51","703":"3de5b196","787":"ca294ad7"}[chunkId] + ".chunk.js";
};